import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  VibeModal,
  color,
} from 'vibeguide';
import ProviderHeader from '../ProviderHeader';

function ProviderVibenomics({
  className = '',
  style = {},
  providerKey,
  providerName = 'Vibenomics',
  onRemoveProvider = () => {},
}) {
  const [confirmRemoveProvider, setConfirmRemoveProvider] = useState(false);

  /**
   * When a user clicks remove on an item, show confirmation modal
   */
  const onClickRemoveProvider = () => {
    setConfirmRemoveProvider(true);
  };

  /**
   * When the user confirms removing the provider
   */
  const onConfirmRemoveProvider = () => {
    setConfirmRemoveProvider(false);
    onRemoveProvider(providerKey);
  };

  /**
   * When the user cancels removing the provider
   */
  const onCancelRemoveProvider = () => {
    setConfirmRemoveProvider(false);
  };

  const adProviderName = providerName;

  return (
    <div
      className={classNames('ProviderVibenomics', className)}
      style={style}
    >
      <ProviderHeader
        title="Vibenomics"
        showRemove
        onClickRemove={onClickRemoveProvider}
      />

      <div
        style={{
          padding: 24,
        }}
      >
        No configuration required
      </div>

      <VibeModal
        show={confirmRemoveProvider}
        type="confirm"
        title="Removing Ad Provider"
        text={(
          <div>
            You are about to remove the
            <span
              style={{
                padding: '0 4px',
                color: color.error,
                fontWeight: 'bold',
              }}
            >
              {adProviderName}
            </span>
            Ad Provider and all configurations. Do you want to proceed?
          </div>
        )}
        confirmProps={{
          color: 'error',
        }}
        testIds={{
          root: 'vibenomics-provider-remove-dialog',
          confirm: 'vibenomics-provider-remove-confirm-button',
          cancel: 'vibenomics-provider-remove-cancel-button',
        }}
        onConfirm={onConfirmRemoveProvider}
        onClose={onCancelRemoveProvider}
      />
    </div>
  );
}

ProviderVibenomics.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  providerKey: PropTypes.string.isRequired,
  providerName: PropTypes.string,
  onRemoveProvider: PropTypes.func,
};

export default ProviderVibenomics;
